import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/company-fields'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'company_fields_list',
          meta: { permissions: ['administrator'] },
          component: Index,
        },
      ],
    },
  ],
};
